"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NightsInfo = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../Calendar/utils");

var _utils2 = require("../../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NightsInfo = function NightsInfo(_ref) {
  var startDateCell = _ref.startDateCell,
      endDateCell = _ref.endDateCell,
      nights = _ref.nights,
      isMobile = _ref.isMobile,
      isHotelVariant = _ref.isHotelVariant;
  var calendarNightsRange = (0, _utils.getRangeNightsString)({
    startDateCell: startDateCell,
    endDateCell: endDateCell
  });
  var nightsInterval = nights || calendarNightsRange;
  var nightsString = nightsInterval && (0, _utils2.convertNightsIntervalToString)(nightsInterval);
  var nightsStringWords = nightsString === null || nightsString === void 0 ? void 0 : nightsString.split(' ');
  return /*#__PURE__*/_react["default"].createElement(NightsBlock, {
    $isMobile: isMobile,
    $isShort: !!nightsStringWords,
    $isHotelVariant: isHotelVariant
  }, nightsStringWords && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, "".concat(nightsStringWords[0])), /*#__PURE__*/_react["default"].createElement("span", null, "\xA0", "".concat(nightsStringWords[1]))));
};

exports.NightsInfo = NightsInfo;

var NightsBlock = _styledComponents["default"].div.withConfig({
  displayName: "NightsInfo__NightsBlock",
  componentId: "sc-19vka5z-0"
})(["display:flex;font-size:14px;line-height:16px;color:", " ", ";"], function (_ref2) {
  var $isHotelVariant = _ref2.$isHotelVariant;
  return $isHotelVariant ? "var(--secondary-color);" : "var(--secondary-header-color);";
}, function (_ref3) {
  var $isMobile = _ref3.$isMobile,
      $isShort = _ref3.$isShort;
  return $isMobile && !$isShort && "\n        flex-direction: column;\n        align-items: center;\n    ";
});